import { render, staticRenderFns } from "./OrderChangeEdit.vue?vue&type=template&id=e1b3e87e"
import script from "./OrderChangeEdit.vue?vue&type=script&lang=js"
export * from "./OrderChangeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports